export const styles = {
  buttonContainer: {
    gap: '12px',
  },
  cancelButton: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '14px 12px',
    gap: '12px',
    width: '70px',
    height: '48px',
    background: '#FFFFFF',
    border: '1px solid #4D6EF5',
    borderRadius: '8px',
  },
};
